import Plugin from './Plugin.js'
// 编辑区自适应plugin
export default class ResizeCanvasPlugin extends Plugin {
	#_obServerDom = null
	constructor(obServerDom) {
		super()
		this.#_obServerDom = obServerDom
	}
	handleResize = entries => {
		for (let entry of entries) {
			const canvasList = this.#_obServerDom.querySelectorAll('canvas')
			const canvasArray = Array.from(canvasList)
			const editorCanvasWrap = document.querySelector('.canvas-container')
			const editorWrap = document.querySelector('.editor-wrap')
			if (this.editor.timelineStoreState.templateStyle !== 'down') {
				if (entry.contentRect.width / entry.contentRect.height >= 1920 / 1080) {
					canvasArray.forEach(canvas => {
						canvas.style.height = '100%'
						canvas.style.width = ''
					})
					editorCanvasWrap.style.height = '100%'
					editorWrap.style.width = ''
				} else {
					canvasArray.forEach(canvas => {
						canvas.style.width = '100%'
						canvas.style.height = ''
					})
					editorCanvasWrap.style.width = '100%'
					editorWrap.style.width = '100%'
				}
			} else {
				if (entry.contentRect.width / entry.contentRect.height >= 1080 / 1920) {
					canvasArray.forEach(canvas => {
						canvas.style.height = '100%'
						canvas.style.width = ''
					})
					editorCanvasWrap.style.height = '100%'
					editorWrap.style.width = ''
				} else {
					canvasArray.forEach(canvas => {
						canvas.style.width = '100%'
						canvas.style.height = ''
					})
					editorCanvasWrap.style.width = '100%'
					editorWrap.style.width = '100%'
				}
			}
		}
	}
	init(editor) {
		if ('ResizeObserver' in window) {
			const resizeObserver = new ResizeObserver(this.handleResize)
			resizeObserver.observe(this.#_obServerDom)
		} else {
			console.log('ResizeObserver 不被当前浏览器支持')
		}
	}
}
